var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1434 13.9896C13.4576 13.9896 13.7137 13.7335 13.7137 13.4193V7.62368H15.4672V13.4309C15.4604 14.7066 14.4191 15.7405 13.1434 15.7405H2.98054C1.70959 15.7262 0.683105 14.6897 0.683105 13.4167V3.25853C0.695252 1.9881 1.73387 0.958984 3.00694 0.958984H8.79986V2.71256H3.00694C2.69277 2.71256 2.43668 2.96865 2.43668 3.28282V13.4193C2.43668 13.7335 2.69277 13.9896 3.00694 13.9896H13.1434ZM10.2471 2.71256V0.958984H15.4677V6.17957H13.7141V3.95447L6.32656 11.3394L5.08728 10.1002L12.4722 2.71256H10.2471Z",
    fill: "#B3BEC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.aacb2bc964e94abefb9b1d4614fedfb6.svg";
export { ForwardRef as ReactComponent };